// extracted by mini-css-extract-plugin
export default {"dark":"styles_dark__YQRIe","copyright":"styles_copyright__RWdQY","appPlay":"styles_appPlay__ue3eD"};